import { render, staticRenderFns } from "./NotaCredito.vue?vue&type=template&id=3bb55f52&scoped=true"
import script from "./NotaCredito.vue?vue&type=script&lang=js"
export * from "./NotaCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb55f52",
  null
  
)

export default component.exports